import { Component } from '@angular/core';
import { assets } from '../../../../core/constants/assets.const';

@Component({
  selector: 'logibids-transport-inq-info',
  imports: [],
  templateUrl: './transport-inq-info.component.html',
  styleUrl: './transport-inq-info.component.scss',
})
export class TransportInqInfoComponent {
  assets = assets;
}
